import DetailViewContentElement from "../../../common/models/detailView/elements/detailViewContentElement";

export default class ModelHistory extends DetailViewContentElement {
  display_initiator: boolean;

  constructor() {
    super();
    this.defineProperty("display_initiator", false)
  }
}